import axios from "axios";

const errorCodes = [401, 403];

export const apiRequest = async (method, url, data = null) => {
    const config = {
        method: method,
        url: `${process.env.REACT_APP_BASEURL}${url}`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Accept': 'application/json'
        },
        data: data
    };

    if (method.toLowerCase() === 'delete') {
        delete config.data;
    } else if (data) {
        config.data = data;
    }

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        if (errorCodes?.includes(error?.response?.status) && localStorage.getItem('token') && error?.response?.data?.error !== 'A organization name already exists. Please use a different name.') {
            localStorage.clear();
            window.location.reload(false);
        }
        throw error;
    }
};

export const publicApiRequest = async (method, url, data = null) => {
    const config = {
        method: method,
        url: `${process.env.REACT_APP_BASEURL}${url}`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('public-token')}`,
            'Accept': 'application/json'
        },
        data: data
    };

    if (method.toLowerCase() === 'delete') {
        delete config.data;
    } else if (data) {
        config.data = data;
    }

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        if (errorCodes?.includes(error?.response?.status) && localStorage.getItem('token') && error?.response?.data?.error !== 'A organization name already exists. Please use a different name.') {
            localStorage.clear();
            window.location.reload(false);
        }
        throw error;
    }
};
